import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({
  value,
  height = 36,
  width = 1.2,
  margin = 0,
  marginTop = margin,
  marginBottom = margin,
  marginLeft = margin,
  marginRight = margin,
  className = '',
  svgClassName = 'w-full max-w-[200px]',
  valueClassName = 'text-xs text-gray-600 mt-1',
}) => {
  const svgRef = useRef(null);
  const normalizedValue = String(value || '').trim();

  useEffect(() => {
    if (!svgRef.current || !normalizedValue) return;

    try {
      JsBarcode(svgRef.current, normalizedValue, {
        format: 'CODE128',
        displayValue: false,
        height,
        width,
        margin,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
      });
    } catch (error) {
      if (svgRef.current) {
        svgRef.current.innerHTML = '';
      }
    }
  }, [normalizedValue, height, width, margin, marginTop, marginBottom, marginLeft, marginRight]);

  if (!normalizedValue) return null;

  return (
    <div className={`flex flex-col items-center ${className}`.trim()}>
      <svg ref={svgRef} className={svgClassName} />
      <span className={valueClassName}>{normalizedValue}</span>
    </div>
  );
};

export default Barcode;
